import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AppDialogBoxConfig, AppDialogBoxResult } from '@ukam/ui-kit/dialog-box/dialog-box.models';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

const ACTION_BUTTONS: Record<string, string[]> = {
  ok:                 ['ok'],
  okCancel:           ['cancel', 'ok'],
  confirmCancel:      ['cancel', 'confirm'],
  retryCancel:        ['cancel', 'retry'],
  yesNo:              ['no', 'yes'],
  yesNoCancel:        ['cancel', 'no', 'yes'],
  saveNoSaveCancel:   ['cancel', 'noSave', 'save'],
  abortRetryIgnore:   ['ignore', 'retry', 'abort'],
};

const FOCUS_BUTTON: Record<string, string> = {
  ok:               'ok',
  okCancel:         'ok',
  confirmCancel:    'confirm',
  retryCancel:      'retry',
  yesNo:            'yes',
  yesNoCancel:      'yes',
  saveNoSaveCancel: 'save',
  abortRetryIgnore: 'abort',
};

@Component({
  selector: 'ajin-dialog-box',
  templateUrl: './dialog-box.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
})
export class AppDialogBoxComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AppDialogBoxComponent>);
  readonly data = inject<AppDialogBoxConfig>(MAT_DIALOG_DATA);

  buttons = new Set<string>();
  result = { text: '' };

  ngOnInit(): void {
    if (!this.data?.actions) return;
    this.buttons = new Set(ACTION_BUTTONS[this.data.actions] ?? []);
    const focusId = FOCUS_BUTTON[this.data.actions];
    if (focusId) setTimeout(() => document.getElementById(focusId)?.focus(), 300);
  }

  has(button: string): boolean {
    return this.buttons.has(button);
  }

  iconColor(): string {
    const map: Record<string, string> = {
      primary: '#6366f1',
      accent:  '#ec4899',
      warn:    '#f59e0b',
      basic:   '#4b5563',
      info:    '#3b82f6',
      success: '#22c55e',
      warning: '#f97316',
      error:   '#ef4444',
    };
    return map[this.data?.icon?.color ?? ''] ?? '';
  }

  confirm(action: AppDialogBoxResult): void {
    if (this.result?.text) action.text = this.result.text;
    this.dialogRef.close(action);
  }
}
